import { ShiftEntity } from 'src/entities/shiftEntity';

/** NULL・1 未満は 1 回転目 (API の ShiftTruckRotation.normalize_cycle と同じ) */
const normalizeCycle = (cycle: number | null | undefined): number => (cycle != null && cycle >= 1 ? cycle : 1);

/**
 * 回転単位でコース番号を持つ勤務 (`rotations` あり) を、運行指示書のページ分け用に回転ごとの勤務に分ける
 * (log_web_issues#352、D2 ルール 7)。各勤務はその回転の operation と伝票だけを持ち、`course_number` は
 * その回転の番号。`rotations` の無い勤務はそのまま返す。
 * Why not API で分ける: `shifts[].id` が勤務 id でなくなり、YC の差分 (to_shift_id) と FE の key が壊れる
 */
export function splitShiftByRotation(entity: ShiftEntity): ShiftEntity[] {
  const rotations = entity.rotations;
  if (!rotations || rotations.length === 0) return [entity];
  // rotations に無い cycle の operation (main_truck 以外の勤務トラックに載った分) は落とさず最初の回転に入れる
  const known = new Set(rotations.map((rotation) => rotation.cycle));
  return rotations.map((rotation, index) => {
    const orderOperations = entity.order_operations.filter((op) => {
      const cycle = normalizeCycle(op.cycle);
      return cycle === rotation.cycle || (index === 0 && !known.has(cycle));
    });
    const orderIds = new Set(orderOperations.map((op) => op.order_id));
    return {
      ...entity,
      course_number: rotation.course_number,
      rotations: undefined,
      // cycle を回転の番号に揃える。NULL・0 と 1 が混ざると ShiftWithCycleModel が別の回転に分け、<n回転目> の見出しが出る
      order_operations: orderOperations.map((op) => ({ ...op, cycle: rotation.cycle })),
      orders: entity.orders.filter((order) => orderIds.has(order.id)),
      rotation_split: { cycle: rotation.cycle, first: index === 0 },
    };
  });
}

/** ページ数の集計と React の key に使う。分けた勤務は id が同じなので回転を付ける */
export function shiftPageKey(entity: ShiftEntity): string {
  return entity.rotation_split ? `${entity.id}-${entity.rotation_split.cycle}` : String(entity.id);
}
